export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes/`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '2256840d-573d-44aa-970b-27a2afe512f2';
export const MODAL_CLOSE_SEC = 2.5;
